import Campaign from "@/models/campaign";
import { CampaignReportData } from "@/models/CampaignReport";
import { MissingBannersReport } from "@/models/reports";
import api from "@/plugins/axios";

const ReportsAPI = {
  async missingBanners(): Promise<MissingBannersReport[]> {
    return api.get(`reports/line_items/missing_banners`);
  },
  async sellersCampaigns(user_ids: string[]): Promise<Campaign[]> {
    return api.get(`reports/sellers/campaigns`, {
      params: { user_ids: user_ids.join(",") },
    });
  },
  async clientCampaignsPerformance(
    company_id: string
  ): Promise<CampaignReportData> {
    return api.get(`reports/company/campaigns_performance`, {
      params: { company_id: company_id },
    });
  },
  async availabilityExportXls(payload: any): Promise<any> {
    return api({
      method: "get",
      url: "/reports/availability/export_xls",
      responseType: "blob",
      params: {
        params: payload,
      },
    });
  },
  async publicClientCampaignsPerformance(
    company_id: string,
    token: string
  ): Promise<CampaignReportData> {
    return api.get(`client_reports/campaigns_performance`, {
      params: { company_id: company_id, token: token },
    });
  },
  async behaviorReport(payload: any): Promise<any> {
    return api.get(`/reports/behavior_report`, { params: payload });
  },
  async campaignsReport(payload: any): Promise<Campaign[]> {
    return api.get("/reports/campaigns_report", { params: payload });
  },
};

export default ReportsAPI;
